import { useMutation } from '@tanstack/react-query';
import type {
  MFACodeValidationResponse,
  MFASetup,
  OtpType,
  TwoFactorAuthResponse,
} from '../services/twoFactorAuthService';
import {
  getMFADetails,
  validateMFAToken,
} from '../services/twoFactorAuthService';

export const useGetMFADetails = () => {
  return useMutation<TwoFactorAuthResponse, Error, MFASetup>({
    mutationFn: async (payload) => {
      const data = await getMFADetails(payload);
      return data;
    },
  });
};

export const useValidateMFAToken = () => {
  return useMutation<MFACodeValidationResponse, Error, OtpType>({
    mutationFn: async (payload) => {
      const data = await validateMFAToken(payload);
      return data;
    },
  });
};
